import { encodeAbiParameters } from "viem";
export var CommandType;
(function (CommandType) {
    CommandType[CommandType["V3_SWAP_EXACT_IN"] = 0] = "V3_SWAP_EXACT_IN";
    CommandType[CommandType["V3_SWAP_EXACT_OUT"] = 1] = "V3_SWAP_EXACT_OUT";
    CommandType[CommandType["PERMIT2_TRANSFER_FROM"] = 2] = "PERMIT2_TRANSFER_FROM";
    CommandType[CommandType["SWEEP"] = 4] = "SWEEP";
    CommandType[CommandType["V2_SWAP_EXACT_IN"] = 8] = "V2_SWAP_EXACT_IN";
    CommandType[CommandType["V2_SWAP_EXACT_OUT"] = 9] = "V2_SWAP_EXACT_OUT";
    CommandType[CommandType["PERMIT2_PERMIT"] = 10] = "PERMIT2_PERMIT";
    CommandType[CommandType["WRAP_ETH"] = 11] = "WRAP_ETH";
    CommandType[CommandType["UNWRAP_WETH"] = 12] = "UNWRAP_WETH";
    CommandType[CommandType["V4_SWAP"] = 16] = "V4_SWAP";
})(CommandType || (CommandType = {}));
const PERMIT_STRUCT = {
    name: "permit",
    type: "tuple",
    components: [
        {
            name: "details",
            type: "tuple",
            components: [
                { name: "token", type: "address" },
                { name: "amount", type: "uint160" },
                { name: "expiration", type: "uint48" },
                { name: "nonce", type: "uint48" },
            ],
        },
        { name: "spender", type: "address" },
        { name: "sigDeadline", type: "uint256" },
    ],
};
const ABI_DEFINITION = {
    [CommandType.V3_SWAP_EXACT_IN]: [
        { type: "address" },
        { type: "uint256" },
        { type: "uint256" },
        { type: "bytes" },
        { type: "bool" },
    ],
    [CommandType.V3_SWAP_EXACT_OUT]: [
        { type: "address" },
        { type: "uint256" },
        { type: "uint256" },
        { type: "bytes" },
        { type: "bool" },
    ],
    [CommandType.PERMIT2_PERMIT]: [PERMIT_STRUCT, { type: "bytes" }],
    [CommandType.PERMIT2_TRANSFER_FROM]: [
        { type: "address" },
        { type: "address" },
        { type: "uint256" },
    ],
    [CommandType.V4_SWAP]: [{ type: "bytes" }, { type: "bytes[]" }],
    [CommandType.WRAP_ETH]: [{ type: "address" }, { type: "uint256" }],
    [CommandType.UNWRAP_WETH]: [{ type: "address" }, { type: "uint256" }],
    [CommandType.V2_SWAP_EXACT_IN]: [
        { type: "address" },
        { type: "uint256" },
        { type: "uint256" },
        { type: "address[]" },
        { type: "bool" },
    ],
    [CommandType.V2_SWAP_EXACT_OUT]: [
        { type: "address" },
        { type: "uint256" },
        { type: "uint256" },
        { type: "address[]" },
        { type: "bool" },
    ],
    [CommandType.SWEEP]: [
        { type: "address" },
        { type: "address" },
        { type: "uint256" },
    ],
};
export class CommandBuilder {
    constructor() {
        this.commands = "0x";
        this.inputs = [];
    }
    addCommand(type, parameters) {
        const encoded = encodeAbiParameters(ABI_DEFINITION[type], parameters);
        this.commands += type.toString(16).padStart(2, "0");
        this.inputs.push(encoded);
        return this;
    }
    addPermit2Permit(permit, signature) {
        return this.addCommand(CommandType.PERMIT2_PERMIT, [permit, signature]);
    }
    addWrapEth(recipient, amount) {
        return this.addCommand(CommandType.WRAP_ETH, [recipient, amount]);
    }
    addUnwrapWeth(recipient, amount) {
        return this.addCommand(CommandType.UNWRAP_WETH, [recipient, amount]);
    }
    addV3SwapExactIn(recipient, amountIn, amountOutMinimum, path, unwrap) {
        return this.addCommand(CommandType.V3_SWAP_EXACT_IN, [
            recipient,
            amountIn,
            amountOutMinimum,
            path,
            unwrap,
        ]);
    }
    addV3SwapExactOut(recipient, amountOut, amountInMaximum, path, payerIsMsgSender) {
        return this.addCommand(CommandType.V3_SWAP_EXACT_OUT, [
            recipient,
            amountOut,
            amountInMaximum,
            path,
            payerIsMsgSender,
        ]);
    }
    addPermit2TransferFrom(token, recipient, amount) {
        return this.addCommand(CommandType.PERMIT2_TRANSFER_FROM, [
            token,
            recipient,
            amount,
        ]);
    }
    addV2SwapExactIn(recipient, amountIn, amountOutMinimum, path, payerIsMsgSender) {
        return this.addCommand(CommandType.V2_SWAP_EXACT_IN, [
            recipient,
            amountIn,
            amountOutMinimum,
            path,
            payerIsMsgSender,
        ]);
    }
    addV2SwapExactOut(recipient, amountOut, amountInMaximum, path, payerIsMsgSender) {
        return this.addCommand(CommandType.V2_SWAP_EXACT_OUT, [
            recipient,
            amountOut,
            amountInMaximum,
            path,
            payerIsMsgSender,
        ]);
    }
    addV4Swap(actions, params) {
        return this.addCommand(CommandType.V4_SWAP, [actions, params]);
    }
    build() {
        return [this.commands, this.inputs];
    }
}
//# sourceMappingURL=CommandBuilder.js.map